import React from 'react';
import logo from '../../logo.png';

const Header = () => {
    return (
        <div className="container">
            <nav className="navbar navbar-default fixed-top flex-md-nowrap p-0">
                <img src={logo} align="left" alt="logo" />
                <span className="navbar-brand col-sm-3 col-md-2 mr-auto">CONSULTA SITUAÇÃO FINANCEIRA</span>
                <ul className="navbar-nav px-3">
                    <li className="nav-item text-nowrap">

                    </li>
                </ul>
            </nav>
        </div>
    )
}

export default Header;